import Preferences from '../subPages/settings/Preferences';

const PreferencesPage = () => <Preferences />;
export default PreferencesPage;
